import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { selectActiveTab } from '../../../../../store/selectors/navigation'
import { Dropdown } from '../../../../../Components/shared/Navbar/Dropdown'
import { DesktopAddAHomeLink } from '../DesktopAddAHomeLink'
import { DesktopHomeLinks } from '../DesktopHomeLinks'
import styles from './YourHomeDropdown.module.scss'
import { selectClientHomes } from '../../../../../store/selectors/client'
import { YOUR_HOME_TAB_GROUPING } from '../../../../../mappings/navigation'

export const YourHomeDropdown = () => {
  const intl = useIntl()
  const activeTab = useSelector(selectActiveTab)
  const isSelected = YOUR_HOME_TAB_GROUPING.includes(activeTab)

  const translations = defineMessages({
    label: {
      id: 'DesktopHeader.yourHomeDropdown.label',
      defaultMessage: 'Your home'
    }
  })

  const homes = useSelector(selectClientHomes)
  const listClassName = homes?.length >= 6 && styles.list

  return (
    <Dropdown listClassName={listClassName} isSelected={isSelected} label={intl.formatMessage(translations.label)}>
      <DesktopHomeLinks />
      <DesktopAddAHomeLink />
    </Dropdown>
  )
}
